import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import type { MenuData } from '../types';

export const useLocationPathCheck = (menuData: MenuData): string | null => {
  const { pathname } = useLocation();

  return useMemo(() => {
    for (const [menuKey, menu] of Object.entries(menuData)) {
      const menuItems = Object.values(menu.items ?? {}).flat();

      const isActive = menuItems.some((item) =>
        matchPath(
          {
            path: item.to,
            end: true,
          },
          pathname
        )
      );

      if (isActive) {
        return menuKey;
      }
    }

    return null;
  }, [pathname, menuData]);
};